import styled from 'styled-components/macro';

const CriteriaSegment = styled('div')`
  width: auto;
  display: flex;
  flex-direction: row;
`;

export default CriteriaSegment;
